export default {
  searchForm: {
    month: "期間",
    previousMonth: "<",
    nextMonth: ">",
    currentMonth: "当月",
    keywordSearch: "キーワード検索",
    keywordSearchPlaceholder: "社員番号、氏名、メールアドレスを入力する",
    search: "検索",
    download: "PDF出力",
    paymentDate: "入金日",
    rangePicker: {
      startDate: "開始日",
      endDate: "終了日",
    },
  },
  columns: {
    workerCode: "社員番号",
    fullNameKanji: "氏名（漢字）",
    fullNameKana: "氏名（カナ）",
    personalEmail: "個人メールアドレス",
    totalCompletion: "合計件数",
    totalCompletionUnit: "{text} 件",
    preTaxAmount: "総支払額",
    preTaxAmountUnit: "{text} 円",
    status: "ステータス",
    month: "対象月",
    editable: "編集可/不可",
    detail: "詳細",
  },
  performanceForm: {
    month: "対応月年 : {month}",
    header: "支払通知書",
    fullNameKanji: "{fullNameKanji}様",
    taxableBusinessNumber: "（課税事業者番号：{taxableBusinessNumber}）",
    accountType: {
      valid: "普通",
      invalid: "当座",
    },
    bankInfo: "振込先：{bankName}　{bankBranchName}　/　{accountType}　/　",
    accountInfo: "口座番号：{accountNumber}　口座名：{accountName}",
    actionButton: {
      btnBack: "戻る",
      btnUpdate: "編集",
      btnSubmit: "保存",
      btnDownload: "PDF出力",
    },
    performanceTable: {
      columns: {
        workName: "業務",
        taskName: "タスク",
        customPrice: "単価",
        customUnitPrice: "（円 / 件）",
        total: "合計件数",
      },
      summary: {
        title: "合計金額",
      },
      footer: {
        date: "上記明細の通り、ママワークス/業務委託料として 支払日：{date}に指定口座に入金します。",
        dateDescription: "※送付後、一定期間内に連絡がない場合は確認済みとします。",
        total: "総支払額（税込）",
        unit: "円",
        consumptionTax: "支払額（税抜）",
        defaultTax: "消費税（10%）",
        customTax: "消費税（8%）",
        consumptionCustomTax: "支払額（税抜）",
      },
    },
    submitSuccess: "実績情報が更新されました。",
    notEditable: "データが存在しないか、アクセス権限がありません。",
  },
  downloadPdfBtn: {
    label: "PDF出力",
    progress:
      "PDFファイルをダウンロードしております。少々お待ちください。\n※ブラウザを閉じると、このダウンロードが失われる可能性があります。",
    error: "サーバーでエラーが発生しました。PDFファイルのダウンロードを再試行してください。",
    networkError: "サーバーへの接続に失敗しました。ネットワーク接続を確認し、再試行してください。",
    timeoutError: "ダウンロードがタイムアウトしました。後で再試行してください。",
  },
}
